// extracted by mini-css-extract-plugin
export default {"root":"SelectInput_root__A1aiR","wrapper":"SelectInput_wrapper__FMUCk","input":"SelectInput_input__CPXx2","error":"SelectInput_error__CoXtB"};